import React from "react";
import { useSelector } from "react-redux";
import {
  List,
  ListItemText,
  ListItem,
  Divider,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Text from "../../Text/Text";
import { RouteService } from "../../../services/route.service";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  box: {
    border: "3px solid red",
    padding: 20,
    maxHeight: "content-height",
  },
  noOrderText: {
    marginTop: 15,
    fontSize: 12,
  },
  spaceTop: {
    marginTop: 10,
  },
  img: {
    width: 60,
  },
  link: {
    cursor: "pointer",
  },
}));

export default function ProfileIncompleteWarning(props) {

  const classes = useStyles();
  const homeState = useSelector((state) => state.homeState);
  const inCompleteDetails = props.inCompleteDetails;

  return (
    <div className={classes.content}>
      <Grid style={{ paddingTop: "50px" }} container spacing={3}>
        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <div className={classes.box}>
            <Text variant={"h6"}>
              Profile Incomplete
            </Text>
            <Divider />
            <Text className={classes.noOrderText}>
              Before you can purchase your first permit you will need to finish
              setting up your driver profile.
            </Text>
            <div>
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
                component="nav"
                aria-labelledby="nested-list-subheader"
              >
                {Object.keys(inCompleteDetails).map((item) => {
                  if (
                    !inCompleteDetails[item].data &&
                    inCompleteDetails[item].required
                  ) {
                    return (
                      <ListItem key={item}>
                        <ListItem component='a' href={RouteService.profilePage(homeState.customerName)}>
                          <ListItemText primary={item} />
                        </ListItem>
                      </ListItem>
                    );
                  }
                })}
              </List>
            </div>
          </div>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  );
}
